export default __webpack_public_path__ + "static/media/img_Register.306bef25.png";